export default __webpack_public_path__ + "ff37cb477175712f6b75299b612805a8.png";